import { render, staticRenderFns } from "./Configurazione.vue?vue&type=template&id=25050328"
import script from "./Configurazione.vue?vue&type=script&lang=js"
export * from "./Configurazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports